// extracted by mini-css-extract-plugin
export var changeIcon = "_5j-4";
export var container = "_5j-0";
export var divider = "_5j-7";
export var externalLinkIcon = "_5j-1";
export var green = "_5j-5";
export var helpCircleIcon = "_5j-3";
export var iconButton = "_5j-2";
export var red = "_5j-6";